import { TransferFileType } from './constants';

export function getTransferFileTypeOrDefault() {
  return localStorage.getItem('TransferFileType') || TransferFileType.Json;
}

export function getExportFileData(transferObject) {
  const fileType = getTransferFileTypeOrDefault();

  if (!transferObject) {
    console.error('Cannot export empty entity.');
    return [];
  }

  switch (fileType) {
    case TransferFileType.Json:
      return [JSON.stringify(transferObject, null, 2), 'json', 'application/json'];
    default:
      console.error('Unrecognized export type.');
      return [];
  }
}

export function getContentFromFileEvent(event, callback) {
  if (!event || !event.target || !event.target.files || event.target.files.length === 0) {
    console.error('Could not import file! Invalid file event.');
    return;
  }

  const fileType = getTransferFileTypeOrDefault();
  const file = event.target.files[0];
  const extension = file.name.split('.').pop();

  const reader = new FileReader();
  reader.onload = function (readerEvent) {
    const fileContent = readerEvent.target.result;
    let content = null;

    // Check file type and also convert its contents to json (if TransferFileType is Json no conversion is needed)
    switch (fileType) {
      case TransferFileType.Json:
        if (extension !== 'json') {
          console.error(`TransferFileType set as Json, but the file extension is not .json (${extension})`);
        } else {
          content = fileContent;
        }
        break;
      default:
        console.error('Unrecognized import type.');
    }

    callback(content);
  };

  reader.readAsText(file);
}

export function parseAndValidateType(serializedEntity, type) {
  const transferObject = JSON.parse(serializedEntity);
  if (!transferObject || !transferObject.Type) return null;
  if (transferObject.Type !== type) {
    console.error(`Received import type does not match current entity: ${transferObject.Type}. Expected: ${type}`);
    return null;
  }
  return transferObject;
}
